import { Component } from "react";
import Page from '../../../containers/page';
import DoctorWorkingHoursComponent from "./doctorWorkingHoursComponent";


class DoctorWorkingHours extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...props.initialData,

        };
    }


    render() {
        return (
            <div className={this.props.autoHideSidebar ? "dashboard dashboard-auto-hide" : "dashboard"}>
                <DoctorWorkingHoursComponent {...this.props} />
            </div>
        )
    }
}

export default Page(DoctorWorkingHours)